import { render, staticRenderFns } from "./PersonStats.vue?vue&type=template&id=59b95855"
import script from "./PersonStats.vue?vue&type=script&lang=js"
export * from "./PersonStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports